
// Mock data for damage report Q2 2025
export const damageReportData = {
  totalOverview: {
    totalDamageOrders: 31,
    uniqueDamagedProducts: 26,
    averageMonthlyDamage: "± 30–35 (geschat)"
  },
  damageReasons: [
    { name: "Verzendlabel verwisseld", value: 12, percentage: 38.71 },
    { name: "Retouraanvraag / niet ontvangen", value: 9, percentage: 29.03 },
    { name: "Beschadigd bij transport / levering", value: 6, percentage: 19.35 },
    { name: "Kleurprobleem (verkeerde kleur)", value: 2, percentage: 6.45 },
    { name: "Product vergeten te leveren", value: 2, percentage: 6.45 }
  ],
  supplierAnalysis: [
    { name: "Luijten-VVZ BV", value: 24, percentage: 77.42 },
    { name: "Akzo Nobel Decorative Coatings", value: 6, percentage: 19.35 },
    { name: "Delta Paints BV", value: 1, percentage: 3.23 }
  ],
  brandAnalysis: [
    { name: "Progold", value: 7, percentage: 22.58 },
    { name: "Sikkens", value: 6, percentage: 19.35 },
    { name: "Sigma", value: 5, percentage: 16.13 },
    { name: "Anza", value: 3, percentage: 9.68 },
    { name: "Lucite", value: 3, percentage: 9.68 },
    { name: "Overige", value: 7, percentage: 22.58 }
  ],
  topDamageProducts: [
    { 
      product: "Pro Viltrol Mini", 
      count: 3, 
      percentage: 9.68,
      note: "Alle 3 met foutief verzendlabel" 
    },
    { 
      product: "Rubbol XD Semi Gloss", 
      count: 2, 
      percentage: 6.45,
      note: "Verkeerde levering / kleur" 
    },
    { 
      product: "192 2K-PUR Xtrem Matt", 
      count: 2, 
      percentage: 6.45,
      note: "Beschadigd of ontbrekend" 
    },
    { 
      product: "Inzetbak Klein", 
      count: 1, 
      percentage: 3.23,
      note: "Minder geleverd dan besteld" 
    },
    { 
      product: "S2U Allure Gloss", 
      count: 1, 
      percentage: 3.23,
      note: "Foutieve variant geleverd" 
    }
  ],
};
